module.exports = __webpack_public_path__ + "static/zqb3_20230209.661ad055.jpg";